import { customAxios as axios, getToken } from '../../../request'
import { notification } from 'antd'
import { getAllCountryStatusListCountUrl } from '../apis'

export const getAllCountryStatusListCount = async (filters) => {
  let config = {
    params: { ...filters },
    ...getToken()
  }
  let resp = await axios.get(getAllCountryStatusListCountUrl(), config)
  if (resp && resp.error) {
    notification.error({
      message: resp.message || 'Error'
    })
  }
  return resp.data
}